<div class="row g-3 mb-2">
  <div class="col-6 col-lg-3">
    <div class="card shadow-sm p-2 d-flex flex-column align-items-start">
      <span class="d-block mb-2 display-6 fw-bold text-primary-dark">{{
        threatPairStats?.totalPairs ?? 0
      }}</span>
      <span class="fs-6 text-muted">Total Threat Pairs</span>
    </div>
  </div>
  <div class="col-6 col-lg-3">
    <div class="card shadow-sm p-2 d-flex flex-column align-items-start">
      <span class="d-block mb-2 display-6 fw-bold text-success">{{
        threatPairStats?.activePairs ?? 0
      }}</span>
      <span class="fs-6 text-muted">Active Pairs</span>
    </div>
  </div>
  <div class="col-6 col-lg-3">
    <div class="card shadow-sm p-2 d-flex flex-column align-items-start">
      <span class="d-block mb-2 display-6 fw-bold text-danger-darker">{{
        threatPairStats?.alertsToday ?? 0
      }}</span>
      <span class="fs-6 text-muted">Alerts Today</span>
    </div>
  </div>
  <div class="col-6 col-lg-3">
    <div class="card shadow-sm p-2 d-flex flex-column align-items-start">
      <span class="d-block mb-2 display-6 fw-bold text-warning">{{
        threatPairStats?.inactivePairs ?? 0
      }}</span>
      <span class="fs-6 text-muted">Inactive Pairs</span>
    </div>
  </div>
</div>

<!-- Toolbar -->
<div
  class="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-2"
  >
  <form
    [formGroup]="monitoredUsersForm"
    class="d-flex flex-wrap align-items-center gap-3 mb-0"
    >
    <app-search
      placeholder="Search threat pairs..."
      (emitSearchKeyword)="receiveSearchKeyword($event)"
    ></app-search>
    <div class="form-check form-switch mb-0 align-items-center d-flex">
      <input
        class="form-check-input"
        type="checkbox"
        id="includeInactive"
        [(ngModel)]="includeInactive"
        [disabled]="loading"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="onIncludeInactiveChange()"
        />
      <label class="form-check-label ms-2" for="includeInactive">
        Include inactive
      </label>
    </div>
    <app-select
      class="select-outline"
      [form]="monitoredUsersForm"
      [control]="monitoredUsersForm.controls['limit']"
      [controlName]="'limit'"
      [filter]="false"
      [data]="limits"
      [name]="'label'"
      [value]="'value'"
      [width]="defaultLimitSelectWidth"
      (emitSelectedValue)="receiveLimitSelected($event)"
    ></app-select>
    <button
      type="button"
      class="btn btn-light bg-white border"
      (click)="filterCollapse.toggle()"
      [attr.aria-expanded]="!filterCollapse.collapsed"
      aria-controls="filterPanel"
      >
      <i-bs [name]="filterCollapse.collapsed ? 'filter' : 'x-lg'"></i-bs> Filter
    </button>
  </form>
  <button
    type="button"
    class="btn btn-primary"
    [disabled]="!addThreatPairListsReady"
    (click)="addThreatPair()"
    >
    <i-bs name="plus"></i-bs> Add Threat Pair
  </button>
</div>

<!-- Filter panel (collapsible) - appears when Filter button is clicked -->
<div class="row" mdbCollapse #filterCollapse="mdbCollapse">
  <div class="col-12">
    <div class="card mb-2">
      <div class="card-body">
        <form [formGroup]="filterForm" (ngSubmit)="applyFilter()">
          <div class="row g-3 mb-3">
            <div class="col-md-3">
              <label for="survivorName" class="form-label">Survivor Name</label>
              <input
                type="text"
                class="form-control"
                id="survivorName"
                formControlName="survivorName"
                placeholder="Survivor name"
                />
            </div>
            <div class="col-md-3">
              <label for="perpetratorName" class="form-label"
                >Perpetrator Name</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="perpetratorName"
                  formControlName="perpetratorName"
                  placeholder="Perpetrator name"
                  />
              </div>
              <div class="col-md-3">
                <label for="filterOrganization" class="form-label"
                  >Organization</label
                  >
                  <app-select
                    [form]="filterForm"
                    [control]="filterForm.controls['organizationIds']"
                    [controlName]="'organizationIds'"
                    [clearButton]="true"
                    [filter]="true"
                    [data]="organizationList"
                    [name]="'label'"
                    [value]="'value'"
                    [placeholder]="'Select all'"
                    [multiple]="true"
                    [width]="'100%'"
                  ></app-select>
                </div>
                <div class="col-md-3">
                  <label for="filterStatus" class="form-label">Status</label>
                  <app-select
                    [form]="filterForm"
                    [control]="filterForm.controls['status']"
                    [controlName]="'status'"
                    [clearButton]="true"
                    [filter]="false"
                    [data]="statusFilterOptions"
                    [name]="'label'"
                    [value]="'value'"
                    [placeholder]="'All'"
                    [width]="'100%'"
                  ></app-select>
                </div>
              </div>
              <div class="row">
                <div class="col-12 d-flex justify-content-end gap-2">
                  <button
                    type="button"
                    class="btn btn-outline-primary"
                    (click)="clearFilter()"
                    [disabled]="loading"
                    >
                    Clear
                  </button>
                  <button type="submit" class="btn btn-primary" [disabled]="loading">
                    @if (loading) {
                      <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    }
                  Search</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div
      #tableElement
      class="table-responsive mt-3 scrollbar-primary thin overflow-auto"
      (scroll)="!loading && onScroll($event)"
      >
      <table class="table align-middle">
        <thead class="bg-gray-light text-gray-dark position-sticky">
          <tr>
            <th>#</th>
            <th>Victim</th>
            <th></th>
            <th>Accused</th>
            <th>Alert radius</th>
            <th>Status</th>
            <th>Last Alert</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @if (loading) {
            <tr>
              <td colspan="8" class="text-center py-5">
                <app-loader [loader]="true"></app-loader>
              </td>
            </tr>
          }
          @if (!loading && threatPairs.length === 0) {
            <tr>
              <td colspan="8" class="text-center py-5 text-muted">
                <i-bs name="journal-text" width="2rem" height="2rem"></i-bs>
                <p class="mt-2 mb-0">
                  {{ notFoundMessage }}
                </p>
              </td>
            </tr>
          }
          @for (pair of threatPairs; track pair; let i = $index) {
            <tr>
              <td>{{ threatPairRowIndexLabel(i) }}</td>
              <td>
                <div class="d-flex align-items-center gap-1">
                  <span
                    class="nav-link avatar avatar-sm p-0 bg-primary-dark text-center text-white fw-bold"
                    >
                    {{ pair.survivor.initials }}
                  </span>
                  <div class="d-flex flex-column gap-0.5">
                    <span class="fw-bold">{{ pair.survivor.name }}</span>
                    <span
                      class="badge rounded-pill bg-opacity-10 bg-info text-info align-self-start"
                      >{{ pair.survivor.organization?.name }}</span
                      >
                    </div>
                  </div>
                </td>
                <td class="text-center">
                  <span>vs</span>
                </td>
                <td>
                  <div class="d-flex align-items-center gap-1">
                    <span
                      class="nav-link avatar avatar-sm p-0 bg-primary-darker text-center text-white fw-bold"
                      >
                      {{ pair.perpetrator.initials }}
                    </span>
                    <div class="d-flex flex-column gap-0.5">
                      <span class="fw-bold">{{ pair.perpetrator.name }}</span>
                      <span
                        class="badge rounded-pill bg-opacity-10 bg-info text-info align-self-start"
                        >{{ pair.perpetrator.organization?.name }}</span
                        >
                      </div>
                    </div>
                  </td>
                  <td>
                    <span
                      class="d-inline-flex align-items-center small fw-medium rounded-3 border border-warning border-opacity-50 text-warning bg-warning bg-opacity-10 px-2"
                      >
                      <i class="fas fa-map-marker-alt me-1"></i>
                      {{ pair.distanceThreshold || 0 }} {{ pair.distanceParameter === 'meter' ? 'm' : pair.distanceParameter === 'feet' ? 'ft' : pair.distanceParameter === 'yard' ? 'yd' : pair.distanceParameter === 'mile' ? 'mi' : '' }}
                    </span>
                  </td>
                  <td>
                    <span
                      class="d-inline-flex align-items-center gap-1 small fw-medium"
            [ngClass]="
              pair.status.toLowerCase() === 'active'
                ? 'text-success'
                : 'text-secondary'
            "
                      >
                      <span
                        class="rounded-circle flex-shrink-0 d-inline-block"
              [ngClass]="
                pair.status.toLowerCase() === 'active'
                  ? 'bg-success'
                  : 'bg-secondary'
              "
                        [style.width.px]="8"
                        [style.height.px]="8"
                      ></span>
                      {{ pair.status | titlecase }}
                    </span>
                  </td>
                  <td>
                    <div class="d-flex flex-column gap-1">
                      <span class="fw-medium text-dark">{{ pair?.lastAlertAt | date:'MM/dd/yyyy'}}</span>
                      @if (pair.lastAlertDistance) {
                        <span
                          class="small text-muted d-inline-flex align-items-center"
                          >
                          <i-bs
                            name="exclamation-triangle-fill"
                            class="text-danger flex-shrink-0 me-1"
                          ></i-bs>
                          {{ pair.lastAlertDistance }} detected
                        </span>
                      }
                    </div>
                  </td>
                  <td class="text-end">
                    <div class="d-flex gap-1 justify-content-end flex-wrap">
                      <button
                        type="button"
                        class="btn btn-sm border-0 rounded-2 text-danger-darker bg-primary-lighter border-danger-darker fw-bold"
                        (click)="onAlerts(pair, pair.distanceParameter ?? 'meter')"
                        >
                        <i-bs name="bell" class="me-1"></i-bs>
                        Alerts
                      </button>
                      <button
                        type="button"
                        class="btn btn-sm rounded-2 text-primary-dark bg-primary-blue-light border border-primary-blue-border-light fw-bold"
                        (click)="onViewProfile(pair)"
                        >
                        <i-bs name="person-fill"></i-bs>
                        View Profile
                      </button>
                      <div class="dropdown" mdbDropdown>
                        <a
                          role="button"
                          class="text-dark"
                          [attr.id]="threatPairDropdownToggleId(pair)"
                          aria-expanded="false"
                          mdbDropdownToggle
                          >
                          <i-bs name="three-dots-vertical"></i-bs>
                        </a>
                        <ul
                          mdbDropdownMenu
                          class="dropdown-menu dropdown-menu-end"
                          [attr.aria-labelledby]="threatPairDropdownToggleId(pair)"
                          >
                          <li>
                            @if (pair.status.toLowerCase() === 'inactive') {
                              <a
                                class="dropdown-item"
                                role="button"
                                (click)="onSetActive(pair); $event.preventDefault()"
                                >Set active</a
                                >
                              }
                            </li>
                            <li>
                              @if (pair.status.toLowerCase() === 'active') {
                                <a
                                  class="dropdown-item"
                                  role="button"
                                  (click)="onSetInactive(pair); $event.preventDefault()"
                                  >Set inactive</a
                                  >
                                }
                              </li>
                              <li>
                                <a
                                  class="dropdown-item"
                                  role="button"
                                  (click)="onEditPair(pair); $event.preventDefault()"
                                  >Edit pair</a
                                  >
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item"
                                    role="button"
                                    (click)="onDeletePair(pair); $event.preventDefault()"
                                    >Delete pair</a
                                    >
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </td>
                        </tr>
                      }
                      @if (loadingMore && threatPairs.length > 0) {
                        <tr>
                          <td colspan="8" class="text-center py-3 border-0 bg-transparent">
                            <span
                              class="spinner-border spinner-border-sm text-primary"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            <span class="visually-hidden">Loading more</span>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>

                <app-threat-pair-alert-log #threatPairAlertLog></app-threat-pair-alert-log>
